<template>
  <v-card class="user-history" tile>
    <v-card-title>{{ this.$t('statistics.memory') }}</v-card-title>
    <div class="pa-2 pl-4">
      <dl class="form-box">
        <dt class="d-table-cell pt-1">{{ this.$t('statistics.category') }}</dt>
        <dd class="d-table-cell">
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk">
              <v-checkbox v-model="memoryVmAll" @click="toggleAll" :label="$t('statistics.memory.checkAll')" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
          <div class="d-flex align-content-start flex-wrap">
            <span class="wrap-sts-chk" v-for="(item, idx) in options" :key="idx">
              <v-checkbox v-model="memoryVm" :label="item.text" :value="item.text" class="sts-comp-chk-mgt-2" hide-details dense></v-checkbox>
            </span>
          </div>
        </dd>
      </dl>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    options: Array,
  },
  data() {
    return {
      memoryVmAll: false,
      memoryVm: [],
    };
  },
  watch: {
    memoryVm(val) {
      const returnVal = {
        val: Object.values(val).join().toUpperCase(), // eslint-disable-line prettier/prettier
        title: this.$t('statistics.memory'),
      };
      this.$emit('changeSapMemory', { ...returnVal }, 'sapMemory');
      this.memoryVmAll = this.options.length === val.length ? true : false;
    },
  },
  created() {
    this.allCheck();
  },
  methods: {
    allCheck() {
      this.memoryVm = [];
      this.options.map(el => this.memoryVm.push(el.text));
    },
    toggleAll() {
      !this.memoryVmAll ? (this.memoryVm = []) : this.allCheck();
    },
  },
};
</script>
